<template>
  <div class="question3" :style="`background: url('${require('../assets/bg20.png')}'); background-size: 100% 100%;`">
    <img class="sub-logo2" src="../assets/logo5.png">
    <div class="content">
      <div class="body">
        <div class="header">
            <img src="../assets/head4.png">
            <div class="title">
              <p class="title_1">SCL-90自测量表</p>
            </div>
        </div>
          <div class="q" v-for="(item,index) in qusertion">
              <van-row class="q_title">
                {{ item.title }}
              </van-row>
              <div class="clear"></div>
              <van-radio-group v-model="q[item.model]">
                <van-radio name="A">A. 没有</van-radio>
                <van-radio name="B">B. 很轻</van-radio>
                <van-radio name="C">C. 中等</van-radio>
                <van-radio name="D">D. 偏重</van-radio>
                <van-radio name="E">E. 严重</van-radio>
              </van-radio-group>
          </div>
          <div class="q_other">91. 最想做的3件事情</div>
          <div>
              <van-field
                v-model="q_1"
                center
                clearable
                label="1"
                label-width ="10px"
              >
              </van-field>
          </div>
          <div>
              <van-field
                v-model="q_2"
                center
                clearable
                label="2"
                label-width ="10px"
              >
              </van-field>
          </div>
          <div>
              <van-field
                v-model="q_3"
                center
                clearable
              label="3"
              label-width ="10px"
              >
              </van-field>
          </div>


          <div class="apply2">
              <van-button type="info" class="apply_title" @click="submit()">提交</van-button>
          </div>
      </div>
    </div>
     <div class="footer"  @click="goback()">
      <img class="goback" src="../assets/goback.png" >
    </div>
    <share></share>
  </div>
</template>

<script>
import { Http } from '@/utils/http.js'
import api   from '@/config/api.js'
// import validator from '@/utils/validator.js'
import Cookies from 'js-cookie'
// import AreaList from '@/utils/area'
// import { pca, pcaa } from 'area-data'
import axios from 'axios'


export default {
  name: 'Question1',
  data() {
    return {
      qusertion: [
        {
          model: 'q1',
          title: '1. 头痛',
          type: 1 
        },
        {
          model: 'q2',
          title: '2. 神经过敏，心中不踏实',
          type: 5 
        },
         {
          model: 'q3',
          title: '3. 头脑中有不必要的想法或字句盘旋',
          type: 2
        },
        {
          model: 'q4',
          title: '4. 头晕或昏倒',
          type: 1 
        },
         {
          model: 'q5',
          title: '5. 对异性的兴趣减退', 
          type: 4
        },
        {
          model: 'q6',
          title: '6. 对旁人责备求全', 
          type: 3
        },
         {
          model: 'q7',
          title: '7. 感到别人能控制你的思想',
          type: 9
        },
        {
          model: 'q8',
          title: '8. 责怪别人制造麻烦',
          type: 8
        },
         {
          model: 'q9',
          title: '9. 忘记性大',
          type: 2
        },
        {
          model: 'q10',
          title: '10. 担心自己的衣饰整齐及仪态的端庄',
          type: 2
        },
         {
          model: 'q11',
          title: '11. 容易烦恼和激动',
          type: 6
        },
        {
          model: 'q12',
          title: '12. 胸痛',
          type: 1 
        },
         {
          model: 'q13',
          title: '13. 害怕空旷的场所或街道',
          type: 7
        },
        {
          model: 'q14',
          title: '14. 感到自己精力下降，活动减慢',
          type: 4
        },
         {
          model: 'q15',
          title: '15. 想结束自己的生命',
          type: 4
        },

         {
          model: 'q16',
          title: '16. 听到旁人听不到声音',
          type: 9
        },
        {
          model: 'q17',
          title: '17. 发抖',
          type: 5
        },
         {
          model: 'q18',
          title: '18. 感到大多数人都不可信任',
          type: 8
        },
        {
          model: 'q19',
          title: '19. 胃口不好',
          type: 10
        },
         {
          model: 'q20',
          title: '20. 容易哭泣',
          type: 4
        },
         {
          model: 'q21',
          title: '21、同异性相处时感到害羞不自在',
          type: 3
        },
        {
          model: 'q22',
          title: '22、感到受骗，中了圈套或有人想抓你',
          type: 4
        },
        {
          model: 'q23',
          title: '23、无缘无故的感觉到害怕',
          type: 5
        },
        {
          model: 'q24',
          title: '24、自己不能控制的大发脾气',
          type: 6
        },
        {
          model: 'q25',
          title: '25、怕单独出门',
          type: 7
        },
        {
          model: 'q26',
          title: '26、经常责怪自己',
          type: 4
        },
        {
          model: 'q27',
          title: '27、腰痛',
          type: 1
        },
        {
          model: 'q28',
          title: '28、感到难以完成任务',
          type: 2
        },
        {
          model: 'q29',
          title: '29、感到孤独',
          type: 4
        },
        {
          model: 'q30',
          title: '30、感到苦闷',
          type: 4
        },
        {
          model: 'q31',
          title: ' 31、过分担忧',
          type: 4
        },
        {
          model: 'q32',
          title: '32、对事物不感兴趣',
          type: 4
        },
        {
          model: 'q33',
          title: '33、感到害怕',
          type: 5
        },
        {
          model: 'q34',
          title: '34、你的感情容易受到伤害',
          type: 3
        },
        {
          model: 'q35',
          title: '35、旁人能知道你的私下想法',
          type: 9
        },
        {
          model: 'q36',
          title: '36、感到别人不理解你不同情你',
          type: 3
        },
        {
          model: 'q37',
          title: '37、感到人们对你不友好，不喜欢你',
          type: 3
        },
        {
          model: 'q38',
          title: '38、做事情必须做得很慢以保证做正确',
          type: 2
        },
        {
          model: 'q39',
          title: '39、心跳得厉害',
          type: 5
        },
        {
          model: 'q40',
          title: '40、恶心或胃不舒服',
          type: 1
        },
        {
          model: 'q41',
          title: '41、感到比不上别人',
          type: 3
        },
        {
          model: 'q42',
          title: '42、肌肉酸痛',
          type: 1
        },
        {
          model: 'q43',
          title: '43、感到有人在监视你谈论你',
          type: 8
        },
        {
          model: 'q44',
          title: '44、难以入睡',
          type: 10
        },
        {
          model: 'q45',
          title: '45、做事必须反复检查',
          type: 2
        },
        {
          model: 'q46',
          title: '46、难以做出决定',
          type: 2
        },
        {
          model: 'q47',
          title: '47、怕乘电车、公共汽车、地铁或火车',
          type: 7
        },
        {
          model: 'q48',
          title: '48、呼吸困难',
          type: 1
        },
        {
          model: 'q49',
          title: '49、一阵阵发冷或发热',
          type: 1
        },
        {
          model: 'q50',
          title: '50、因为感到害怕而避开某些东西、场合或活动',
          type: 7
        },
         {
          model: 'q51',
          title: '51、脑子变空了',
          type: 2
        },
        {
          model: 'q52',
          title: '52、身体发麻或刺痛',
          type: 1
        },
        {
          model: 'q53',
          title: '53、喉咙有梗塞感',
          type: 1
        },
        {
          model: 'q54',
          title: '54、感到前途没有希望',
          type: 4
        },
        {
          model: 'q55',
          title: '55、不能集中注意力',
          type: 2
        },
        {
          model: 'q56',
          title: '56、感到身体的某一部分软弱无力',
          type: 1
        },
        {
          model: 'q57',
          title: '57、感到紧张或容易紧张',
          type: 5
        },
        {
          model: 'q58',
          title: '58、感到手或脚发重',
          type: 1
        },
        {
          model: 'q59',
          title: '59、感到死亡的事',
          type: 10
        },
         {
          model: 'q60',
          title: '60、吃得太多',
          type: 10
        },
           {
          model: 'q61',
          title: '61、当别人看着你或谈论你时感到不自在',
          type: 3
        },
           {
          model: 'q62',
          title: '62、有一些属于你自己的看法',
          type: 9
        },
           {
          model: 'q63',
          title: '63、有想打人或伤害他人的冲动',
          type: 6
        },
           {
          model: 'q64',
          title: '64、醒得太早',
          type: 10
        },
           {
          model: 'q65',
          title: '65、必须反复洗手、点数目或触摸某些东西',
          type: 2
        },
           {
          model: 'q66',
          title: '66、睡得不稳不深',
          type: 10
        },
           {
          model: 'q67',
          title: '67、有想摔坏或破坏东西的冲动',
          type: 6
        },
           {
          model: 'q68',
          title: '68、有一些别人没有的想法或念头',
          type: 8
        },
           {
          model: 'q69',
          title: '69、感到对别人神经过敏',
          type: 3
        },
        {
          model: 'q70',
          title: '70、在商场或电影院等人多的地方感到不自在',
          type: 7
        },
         {
          model: 'q71',
          title: '71、感到任何事情都很困难',
          type: 4
        },
         {
          model: 'q72',
          title: '72、一阵阵恐惧或惊恐',
          type: 5
        },
         {
          model: 'q73',
          title: '73、感到在公共场合吃东西很不舒服',
          type: 3
        },
         {
          model: 'q74',
          title: '74、经常与人争论',
          type: 6
        },
         {
          model: 'q75',
          title: '75、单独一个人时神经很紧张',
          type: 7
        },
         {
          model: 'q76',
          title: '76、别人对你的成绩没有做出恰当的评论',
          type: 8
        },
         {
          model: 'q77',
          title: '77、即使和别人在一起也感到孤独',
          type: 9
        },
         {
          model: 'q78',
          title: '78、感到坐立不安心神不定',
          type: 5
        },
         {
          model: 'q79',
          title: '79、感到自己没有什么价值',
          type: 4
        },
         {
          model: 'q80',
          title: '80、感到熟悉的东西变陌生或不象真的',
          type: 5
        },
           {
          model: 'q81',
          title: '81、大叫或摔东西',
          type: 6
        },
          {
          model: 'q82',
          title: '82、害怕会在公共场合昏倒',
          type: 7
        },
          {
          model: 'q83',
          title: '83、感到别人想占你便宜',
          type: 8
        },
          {
          model: 'q84',
          title: '84、为一些有关“性”的想法而苦恼',
          type: 9
        },
          {
          model: 'q85',
          title: '85、你认为应该因为自己的过错而受惩罚',
          type: 9
        },
          {
          model: 'q86',
          title: '86、感到要赶快把事情做完',
          type: 5
        },
          {
          model: 'q87',
          title: '87、感到自己的身体有严重问题',
          type: 9
        },
          {
          model: 'q88',
          title: '88、从未感到和其他人亲近',
          type: 9
        },
          {
          model: 'q89',
          title: '89、感到自己有罪',
          type: 10
        },
          {
          model: 'q90',
          title: '90、感到自己的脑子有毛病',
          type: 9
        },
        
      ],
      q_1: '',
      q_2: '',
      q_3: '',
      id: 0, // 最想去的地方
      q: [],
      isSubmit: false,
      type1: [],
      type2: [],
      type3: [],
      type4: [],
      type5: [],
      type6: [],
      type7: [],
      type8: [],
      type9: [],
      type10: []
    };
  },

  methods: {
      // 返回上一页
    goback(){
      this.$router.go(-1)
    },
    // 判断是否答题
    isAnswer(q, answer){
      console.log('答案--111')
      console.log(answer)
      if(answer.length == 0){
        this.$dialog.alert({
          message: '第' +q + '题没有选择'
        });
        return false;
      }
      return true
    },
     // 弹框
    customAlert(msg){
      this.$dialog.alert({
          message: msg
      });
      return
    },
     // 弹框 确定后返回列表
    customAlert2(msg){
      this.$dialog.alert({
          message: msg
      }).then(
        ()=> {
         // this.$router.go(-1);//返回上一层
        }
      )
      return
    },
    // 获取分数
    getScore(answer,type) {
      var score = 0
       switch(answer){
          case 'A':
              score = 1
            break
          case 'B':
              score = 2
            break
          case 'C':
              score = 3
            break
          case 'D':
              score = 4
          case 'E':
              score = 5
            break
        }   
      return score
    },
    // 判断类型
    getQuestionType(q){
      if(this.type1.includes(q)){
        return 1
      }
      if(this.type2.includes(q)){
        return 2
      }
       if(this.type3.includes(q)){
        return 3
      }
       if(this.type4.includes(q)){
        return 4
      }
       if(this.type5.includes(q)){
        return 5
      }
       if(this.type6.includes(q)){
        return 6
      }
       if(this.type7.includes(q)){
        return 7
      }
       if(this.type8.includes(q)){
        return 8
      }
       if(this.type9.includes(q)){
        return 9
      }

      return 10
    },
    // 获取用户最想做的事情
    getAnswer2(){
      let data = {}
      data.uid = this.uid
      Http.post(api.getAnswer2, data).then((response) => {
        if(Object.keys(response.data).length > 0){
          this.id = response.data.id
          const answer = JSON.parse(response.data.answer);
          this.q_1 = answer.q_1
          this.q_2 = answer.q_2
          this.q_3 = answer.q_3
        } 
        return false
      })

      return false;
    },
    // 提交数据
    submit(){
      if(this.isSubmit){
        this.customAlert('正在提交')
        return false
      }
      // 判断是否楼选
      if(Object.keys(this.q).length < 90){
        this.customAlert('还有选项没有选择')
        return false
      }
      this.isSubmit = true
      // 计算总分
      // 提交数据
      let data = {}
      data.uid = Cookies.get('uid');
      data.question = 3;
      data.answer = this.q;
      // 计算总分
      var totalScore = 0
      var t1 = 0
      var t2 = 0
      var t3 = 0
      var t4 = 0
      var t5 = 0
      var t6 = 0
      var t7 = 0
      var t8 = 0
      var t9 = 0
      var t10 = 0
      var t11 = 0
      for (let value in this.q) {
        let type = this.getQuestionType(value)
        var current  = this.getScore(this.q[value], type)
        switch(type) {
          case 1:
            t1 = t1 + current
            break;
          case 2:
            t2 = t2 + current
            break;
           case 3:
            t3 = t3 + current
            break;
           case 4:
            t4 = t4 + current
            break;
           case 5:
            t5 = t5 + current
            break;
             case 6:
            t6 = t6 + current
            break;
           case 7:
            t7 = t7 + current
            break;
             case 8:
            t8 = t8 + current
            break;
           case 9:
            t9 = t9 + current
            break;
          case 10:
            t10 = t10 + current
            break;
          default:
            t10 = t10 + current
            break;
        }
        totalScore = totalScore + current
      }
      // 计算平均值
      const p1 = (t1/this.type1.length).toFixed(1)
      const p2 = (t2/this.type2.length).toFixed(1)
      const p3 = (t3/this.type3.length).toFixed(1)
      const p4 = (t4/this.type4.length).toFixed(1)
      const p5 = (t5/this.type5.length).toFixed(1)
      const p6 = (t6/this.type6.length).toFixed(1)
      const p7 = (t7/this.type7.length).toFixed(1)
      const p8 = (t8/this.type8.length).toFixed(1)
      const p9 = (t9/this.type9.length).toFixed(1)
      const p10 = (t10/this.type10.length).toFixed(1)

      const p11 = ((Number(p1) + Number(p2) + Number(p3) + Number(p4) + Number(p5) + Number(p6) + Number(p7) + Number(p8) + Number(p9) + Number(p10))/10).toFixed(1)
      t11 = totalScore

      data.answer.totalScore = totalScore
      data.answer.p1 = p1
      data.answer.p2 = p2
      data.answer.p3 = p3
      data.answer.p4 = p4
      data.answer.p5 = p5
      data.answer.p6 = p6
      data.answer.p7 = p7
      data.answer.p8 = p8
      data.answer.p9 = p9
      data.answer.p10 = p10
      data.answer.p11 = p11
      data.answer.t1 = t1
      data.answer.t2 = t2
      data.answer.t3 = t3
      data.answer.t4 = t4
      data.answer.t5 = t5
      data.answer.t6 = t6
      data.answer.t7 = t7
      data.answer.t8 = t8
      data.answer.t9 = t9
      data.answer.t10 = t10
      data.answer.t11 = t11
      let answer2 = {}
      answer2.q_1 = this.q_1
      answer2.q_2 = this.q_2
      answer2.q_3 = this.q_3
      data.answer2 = answer2
      data.id = this.id
      Http.post(api.answer, data).then((response) => {
          this.isSubmit = false
          if(response.code == 1){
            // 提交成功
            this.customAlert('提交成功')
            this.$router.push({ name: "Result3", query: { p1: p1, t1: t1,p2: p2, t2: t2,p3: p3, t3: t3,p4: p4, t4: t4,p5: p5, t5: t5,p6: p6, t6: t6,p7: p7, t7: t7,p8: p8, t8: t8,p9: p9, t9: t9,p10: p10, t10: t10,p11: p11, t11: t11, } })
            return false
          }else{
            // 发送失败
            this.customAlert(response.msg)
            return false
          }
      })

      return false;
    }
  },
  mounted: function() {
    // uid 如果不存在则根据openid 获取uid
    this.uid = Cookies.get('uid')
    // 如果用户ID 不存在去首页
    // 根据uid 获取最想去的地方的答题数据
    if(this.uid){
      this.getAnswer2()
    }
    for (let value in this.qusertion) {
        switch(this.qusertion[value].type){
          case 1 :
             this.type1.push(this.qusertion[value].model)
            break;
          case 2 :
             this.type2.push(this.qusertion[value].model)
            break;
          case 3 :
             this.type3.push(this.qusertion[value].model)
            break;
          case 4 :
             this.type4.push(this.qusertion[value].model)
            break;
          case 5 :
             this.type5.push(this.qusertion[value].model)
            break;
          case 6 :
             this.type6.push(this.qusertion[value].model)
            break;
          case 7 :
             this.type7.push(this.qusertion[value].model)
            break;
          case 8 :
             this.type8.push(this.qusertion[value].model)
            break;
          case 9 :
             this.type9.push(this.qusertion[value].model)
            break;
          default:
             this.type10.push(this.qusertion[value].model)
            break;
        }
    }

    document.title = 'SCL90自评量表'
  }

};
</script>

<style lang="less">
.question3 {
  font-size: 16px;
   display: flex;
    height: 100vh;
    flex-direction: column;

     .sub-logo2 {
        position: absolute;
        width: 40px;
        top: 20px;
        right: 20px;    
    }
  .content {
    position: relative;
    overflow: hidden;
    height: 90%;
    background-color: #fff;
    margin: 60px 20px;
    .el-input--suffix {
      width: 160px;
    }
    .el-input__icon {
      line-height: 22px;
    }
    .el-input--suffix .el-input__inner {
      padding-right: 18px;
      height: 30px;
    }
    .van-field__label {
      width: 120px;
    }
    .van-cell {
      font-size: 16px;
    }
    .van-col {
      margin-bottom: 20px;
    }
    .van-field__body {
      border-bottom: 2px solid #f7f7f7;
    }
    .van-picker__cancel {
      display: none;
    }
    .van-picker__title {
      margin-left: 20px;
      color: #58585d;
      background: #fff;
    }
    .clear{
      clear:both
    }
     .van-radio__label { 
      font-size: 12px;
    }
    .van-radio {
      margin: 12px;
    }
    .van-checkbox {
      margin-left: 12px;
    }
    .van-checkbox__label {
      margin: 12px;
      text-align: left;
    }

    .other{
      padding: 0px;
      text-align: left;
    }
    .body {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    overflow-x: hidden;
    overflow-y: scroll;
    .header {
      position: relative;
      img {
        width: 100%;
        display: block;
      }
      .title {
        .title_1 {
          position: absolute;
          top: 36px;
          font-size: 20px;
          left: 30px;
          color: #34afe8;
        }
      }
    }
      margin-left: 12px;
      .q {
        margin-left: 16px;
        margin-right: 12px;
        .q_title {
          float: left;
          text-align: left;
        }
      }
      .q_other {
        margin-left: 16px;
      }
      .apply2 {
        text-align: center;
        margin-bottom: 12px;
        // position: relative;
       // margin-top: 24px;
        .apply_title {
          // position: absolute;
          // left: 50%;
          // transform: translate3d(-50%,-50%,0);
            width: 100px;
              height: 40px;
              border-radius: 4px;
              font-size: 18px;
          color: #007bf7;
          background-color: #fff;
          border-radius: 1rem;
          margin-bottom: 12px;
        }
      }
    }
  }
    .footer {
      position: fixed;
      bottom: 0px;
      right: 0;
      .goback {
        width: 120px
      }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Question3.vue